import { useState } from "react";
import { toast } from "react-toastify";
import { uploadProfilePhoto } from "../../../services/FileUploadService";
import { useDispatch, useSelector } from "react-redux";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { useAxiosInstance } from "../../../services/Interceptor";
import { fetchProfilePhoto } from "../../../store/AthleteActions";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudUpload } from "@fortawesome/free-solid-svg-icons";

export const ProfileSettings = ({ setProfilePicture, profilePicture }) => {
  const [isUploading, setIsUploading] = useState(false);
  const dispatch = useDispatch();
  const authUser = useAuthUser();
  const apiInstance = useAxiosInstance();
  const { profilePhoto } = useSelector((state) => state.athletes);

  const validateFile = (file) => {
    const permittedExtensions = [".jpg", ".jpeg", ".png", ".gif"];
    const permittedMimeTypes = ["image/jpeg", "image/png", "image/gif"];
    const maxFileSize = 10 * 1024 * 1024;

    const fileExtension = file.name
      .substring(file.name.lastIndexOf("."))
      .toLowerCase();
    const isExtensionValid = permittedExtensions.includes(fileExtension);
    const isMimeTypeValid = permittedMimeTypes.includes(file.type);
    const isSizeValid = file.size <= maxFileSize;

    if (!isExtensionValid) {
      toast.error(
        "Invalid file extension. Only JPG, PNG, and GIF are allowed.",
        {
          position: "top-right",
        },
      );
      return false;
    }

    if (!isMimeTypeValid) {
      toast.error("Invalid file type. Please upload an image file.", {
        position: "top-right",
      });
      return false;
    }

    if (!isSizeValid) {
      toast.error("File size exceeds the 10 MB limit.", {
        position: "top-right",
      });
      return false;
    }

    return true;
  };
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];

    if (!file || !validateFile(file)) {
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setIsUploading(true);
      await uploadProfilePhoto(apiInstance, formData);
      setTimeout(() => {
        dispatch(fetchProfilePhoto(apiInstance, authUser?.user?.id));
        setProfilePicture(profilePhoto);
        setIsUploading(false);
      }, 2000);
      toast.success("Photo uploaded successfully!", { position: "top-right" });
    } catch (error) {
      toast.error("Failed to upload photo!", { position: "top-right" });
      setIsUploading(false);
    }
  };

  const handleDragDropUpload = async (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];

    if (!file || !validateFile(file)) {
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setIsUploading(true);
      await uploadProfilePhoto(apiInstance, formData);
      setTimeout(() => {
        dispatch(fetchProfilePhoto(apiInstance, authUser?.user?.id));
        setProfilePicture(profilePhoto);
        setIsUploading(false);
      }, 2000);
      toast.success("Photo uploaded successfully!", { position: "top-right" });
    } catch (error) {
      toast.error("Failed to upload photo!", { position: "top-right" });
      setIsUploading(false);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };
  return (
    <div className="bg-white shadow-lg p-4 rounded-lg border-gray-300">
      <div className="w-full">
        <h2 className="text-xl mb-4 uppercase"> Profile Settings</h2>
        <div className="grid grid-cols-3 gap-4">
          <div
            className="flex items-center justify-items-end"
            onDrop={handleDragDropUpload}
            onDragOver={handleDragOver}
          >
            {isUploading ? (
              <div className="border border-blue-700 border-dashed rounded-lg p-4 bg-[#E6E3E3] flex items-center justify-center">
                <LoadingSpinner />
              </div>
            ) : profilePicture ? (
              <div className="relative border border-blue-700 border-dashed rounded-lg cursor-pointer px-4 py-4 bg-[#E6E3E3]">
                <img
                  src={profilePicture.fileUrl}
                  alt="Profile"
                  className="h-[148px] w-[148px] object-cover rounded-lg"
                />
                <label
                  htmlFor="Upload"
                  className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity"
                >
                  <FontAwesomeIcon
                    icon={faCloudUpload}
                    className="text-white h-6"
                  />
                  <p className="mb-2 text-sm text-white text-center">
                    <span className="font-normal">
                      Drag and drop or click to upload image
                    </span>
                  </p>
                </label>
                <input
                  id="Upload"
                  type="file"
                  className="hidden"
                  onChange={handleFileUpload}
                />
              </div>
            ) : (
              <label
                htmlFor="Upload"
                className="border border-blue-700 border-dashed rounded-lg cursor-pointer px-4 py-4 bg-[#E6E3E3]"
              >
                <div className="flex flex-col items-center">
                  <FontAwesomeIcon
                    icon={faCloudUpload}
                    className="text-gray-600 h-6"
                  />
                  <p className="mb-2 text-sm text-gray-500 text-center">
                    <span className="font-normal">
                      Drag & Drop Image Or Click to Upload
                    </span>
                  </p>
                </div>
                <input
                  id="Upload"
                  type="file"
                  className="hidden"
                  onChange={handleFileUpload}
                />
              </label>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
